import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { SolSettingKey, SolTableLayout, TableTools } from '@sol/components';

export interface AsmTableLayoutSettings {
  contextChanges?(): Observable<unknown>;
  tableKey(tableId: string): SolSettingKey<SolTableLayout>;
  ownsTableLayout(tableId: string): boolean;
}

export const ASM_TABLE_LAYOUT_SETTINGS = new InjectionToken<AsmTableLayoutSettings>('asm-table-layout-settings', {
  providedIn: 'root',
  factory: () => ({
    tableKey: tableId => SolSettingKey.of(`asm:table:${tableId}:columns`, TableTools.toStoredLayout),
    ownsTableLayout: () => true,
  }),
});
